import React, { useCallback } from "react";
import EntrySummaryForm from "./EntrySummaryForm";
import { FixedSizeList as List } from 'react-window';


const EntrySummaryRepeatable = ({formData={}, onChange}) => {
    const dataArray = Object.values(formData);

    const renderItem = useCallback(({ index, key, isScrolling, style }) =>{
        const item = dataArray[index];
        return <div
            style={style}
            key={key}
        >
                {isScrolling ? 'Loading...' : <EntrySummaryForm
                formData={item}
                onChange={onChange}
            />}
        </div>
    }
            
    , [])
    return <List
        height={600}
        itemCount={dataArray.length}
        itemSize={50}
        style={{width: "100%"}}
        overscanCount={20}
    >
        {renderItem}
    </List>
}
 
export default EntrySummaryRepeatable;